import { OrderTypeEnum } from 'features/common/types';
import { getCoinsByOrderType, postFormData } from 'features/payment/services';
import { IFilledOrderForm, OrderCreatedResult } from 'features/payment/types';
import { ITransactionFullDetails } from '../types';
import { fetchPaymentContactData } from './fetchPaymentContactData';

export interface BuildDLocalOrderParams {
	details: ITransactionFullDetails;
	plCountryCode: string;
}

export const resolveDLocalCoinId = async (coinCode: string): Promise<number> => {
	const response = await getCoinsByOrderType(OrderTypeEnum.DLOCAL);
	const coins = response.data;
	const match = coins.find((c) => c.code.toUpperCase() === coinCode.toUpperCase());
	if (match) return match.id;
	const usd = coins.find((c) => c.code.toUpperCase() === 'USD');
	if (usd) return usd.id;
	if (coins.length > 0) return coins[0].id;
	throw new Error('No hay monedas habilitadas para órdenes DLocal.');
};

export const buildDLocalOrderFromTransaction = async ({
	details,
	plCountryCode,
}: BuildDLocalOrderParams): Promise<OrderCreatedResult> => {
	const td = details.transaction.transactionData;
	const pending = td.pendingAuthorization;

	if (pending <= 0) {
		throw new Error('No hay monto pendiente de autorizar para cobrar por DLocal.');
	}

	const contact = await fetchPaymentContactData(td.crmTicket, td.isBitrixDeal);
	const coinId = await resolveDLocalCoinId(td.coinCode);

	const orderForm: IFilledOrderForm = {
		orderType: OrderTypeEnum.DLOCAL,
		crmTicket: td.crmTicket,
		isBitrixDeal: td.isBitrixDeal,
		name: contact.name || details.saleOrder?.mainPassengerCompleteName || td.cardholder,
		email: contact.email,
		phone: contact.phone,
		coinId,
		amount: pending,
		plCountryCode,
	};

	const response = await postFormData(orderForm);
	return response.data;
};
